const TIME_BRACKET = /^\[[^\]]*\]/;

export const POLL_MIN_MS = 20_000;
export const POLL_MAX_MS = 40_000;
export const FIRST_FEED_OFFSET_MIN_S = 20;
export const FIRST_FEED_OFFSET_MAX_S = 60;

function getBackendUrl() {
  return (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");
}

export function nextPollDelayMs(random = Math.random) {
  return POLL_MIN_MS + Math.floor(random() * (POLL_MAX_MS - POLL_MIN_MS + 1));
}

export function randomFirstFeedOffsetSeconds(random = Math.random) {
  return (
    FIRST_FEED_OFFSET_MIN_S +
    Math.floor(random() * (FIRST_FEED_OFFSET_MAX_S - FIRST_FEED_OFFSET_MIN_S + 1))
  );
}

export function subtractSecondsFromOccurredAt(occurredAt, seconds) {
  if (!occurredAt || typeof seconds !== "number" || !Number.isFinite(seconds)) {
    return occurredAt;
  }
  const date = new Date(occurredAt);
  if (Number.isNaN(date.getTime())) {
    return occurredAt;
  }
  date.setUTCSeconds(date.getUTCSeconds() - seconds);
  return date.toISOString().replace(/\.\d{3}Z$/, "Z");
}

export function formatLocalTime(occurredAt) {
  if (!occurredAt) return "";
  const date = new Date(occurredAt);
  if (Number.isNaN(date.getTime())) return "";
  return date.toLocaleTimeString(undefined, {
    hour12: false,
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });
}

export function formatFeedLine(payload) {
  if (!payload || typeof payload.text !== "string" || !payload.text) {
    return "";
  }
  const local = formatLocalTime(payload.occurred_at);
  if (!local) return payload.text;
  if (TIME_BRACKET.test(payload.text)) {
    return payload.text.replace(TIME_BRACKET, `[${local}]`);
  }
  return `[${local}] ${payload.text}`;
}

export function feedTimeLabel(line) {
  if (typeof line !== "string" || !line) {
    return "";
  }
  const match = TIME_BRACKET.exec(line);
  if (!match) {
    return "";
  }
  return match[0].slice(1, -1);
}

export function hasSameFeedSecond(lines, incomingLine) {
  const incomingTime = feedTimeLabel(incomingLine);
  if (!incomingTime) {
    return false;
  }
  const existing = Array.isArray(lines) ? lines : [];
  return existing.some((entry) => {
    const line = typeof entry === "string" ? entry : entry?.line;
    return feedTimeLabel(line) === incomingTime;
  });
}

export async function fetchLiveLeadNotification() {
  const backendUrl = getBackendUrl();
  if (!backendUrl) {
    return { ok: false, skipped: true };
  }

  try {
    const res = await fetch(`${backendUrl}/api/marketing/live-lead-notification`, {
      method: "GET",
      headers: { Accept: "application/json" },
      cache: "no-store",
    });
    if (!res.ok) {
      return { ok: false, status: res.status };
    }
    const data = await res.json();
    if (!data || typeof data.text !== "string") {
      return { ok: false };
    }
    return { ok: true, data };
  } catch {
    return { ok: false };
  }
}
